<template>
  <div :id="pageId" :class="contentClasses">
    <slot />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"

export default {
  props: {
    noInnerScroll: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
    white: { type: Boolean, default: false },
    darkMode: { type: Boolean, default: false },
    pageId: { type: String, default: "" }
  },

  computed: {
    ...mapGetters("tabbar", ["isTabbarShown"]),
    ...mapState("responsive", ["isDesktop"]),

    contentClasses() {
      const classes = ["v-page"]

      if (this.pageClass) classes.push(this.pageClass)
      if (this.noInnerScroll) classes.push("--no-scroll")
      if (this.noPadding) classes.push("--no-bottom-padding")
      if (this.white) classes.push("--white")
      if (this.darkMode) classes.push("--dark-mode")
      if (this.isTabbarShown && this.isDesktop)
        classes.push("--with-left-sidebar")

      return classes
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.v-page {
  padding-bottom: 10rem;
  margin: 0 auto;
  background: $color-ui--grey-10;
  min-height: 100vh;

  &.--no-scroll {
    position: relative;
  }

  &.--white {
    background: $color-ui--white;
  }

  &.--no-bottom-padding {
    padding-bottom: 0;
  }
}
</style>

<style lang="scss">
@import "@/assets/styles/variables";

@media screen and (min-width: $breakpoint--xl) {
  .v-page {
    .v-tabs {
      .v-page {
        padding-left: initial;
      }
    }

    &.--with-left-sidebar {
      padding-left: $tabbar--desktop-width;
    }
  }
}
</style>
